var _rect, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 1500",
    preserveAspectRatio: "xMidYMid slice",
    style: {
      width: "100%",
      height: "100%",
      display: "absolute",
      top: 0
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ee5522",
    width: "100%",
    height: "100%"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee5522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 750,
    x2: 1550,
    y2: 750
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa8b1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee5522"
  })), /*#__PURE__*/React.createElement("path", {
    id: "s",
    fill: "url(#b)",
    d: "M1549.2 51.6c-5.4 99.1-20.2 197.6-44.2 293.6c-24.1 96-57.4 189.4-99.3 278.6c-41.9 89.2-92.4 174.1-150.3 253.3c-58 79.2-123.4 152.6-195.1 219c-71.7 66.4-149.6 125.8-232.2 177.2c-82.7 51.4-170.1 94.7-260.7 129.1c-90.6 34.4-184.4 60-279.5 76.3C192.6 1495 96.1 1502 0 1500c96.1-2.1 191.8-13.3 285.4-33.6c93.6-20.2 185-49.5 272.5-87.2c87.6-37.7 171.3-83.8 249.6-137.3c78.4-53.5 151.5-114.5 217.9-181.7c66.5-67.2 126.4-140.7 178.6-218.9c52.3-78.3 96.9-161.4 133-247.9c36.1-86.5 63.8-176.2 82.6-267.6c18.8-91.4 28.6-184.4 29.6-277.4c0.3-27.6 23.2-48.7 50.8-48.4s49.5 21.8 49.2 49.5c0 0.7 0 1.3-0.1 2L1549.2 51.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#s",
    transform: "scale(0.12) rotate(60)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    transform: "scale(0.2) rotate(10)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    transform: "scale(0.25) rotate(40)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    transform: "scale(0.3) rotate(-20)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    transform: "scale(0.4) rotate(-30)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    transform: "scale(0.5) rotate(20)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    transform: "scale(0.6) rotate(60)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    transform: "scale(0.7) rotate(10)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    transform: "scale(0.835) rotate(-40)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    transform: "scale(0.9) rotate(40)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    transform: "scale(1.05) rotate(25)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    transform: "scale(1.2) rotate(8)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    transform: "scale(1.333) rotate(-60)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    transform: "scale(1.45) rotate(-30)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    transform: "scale(1.6) rotate(10)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(320 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 975)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    r: 3000
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    r: 2000
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    r: 1800
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    r: 1700
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    r: 1651
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    r: 1450
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    r: 1250
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    r: 1175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    r: 900
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    r: 750
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    r: 500
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    r: 380
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    r: 250
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-108 0 0)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#g",
    transform: "rotate(10)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#g",
    transform: "rotate(120)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#g",
    transform: "rotate(240)"
  })), /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0,
    fill: "url(#a)",
    r: 3000
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.017eab3e22090fe7d8d53a18f27799ae.svg";
export { ForwardRef as ReactComponent };